import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

// import styles
import './deliverydatechangemodal.scss'

// import components
import Modal from '../../components/Modal'
// import { hasAccess } from '../../../utils/auth'
import { renderFullDate } from '../../../utils/time'
import { translation } from '../../../utils/helpers'
import { hasSubscriptionPermission } from '../../../utils/auth'

// Elements
import Radio from '../../elements/radio'
import Button from '../../elements/button'
import Textarea from '../../elements/textarea'
import DropDown from '../../elements/dropDown'
import LabelWrapper from '../../elements/labelWrapper'
import Inline from '../../elements/inline'
import Divider from '../../elements/divider'
import Check from '../../elements/check'

import { ModalIcons } from '../../elements/icons'

class DeliveryDateChangeModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      overflowHidden: false,
      oldDate: '',
      newDate: '',
      shopName: '',
      clientName: '',
      reason: 1,
      comment: '',
      confirmed: false,
      isCustomerDraft: false,
      ApplyToInvoice: false,
      ShowToCustomer: false
    }
    this.renderForm = this.renderForm.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onSave = this.onSave.bind(this)
    this.onClose = this.onClose.bind(this)
    this.renderCustomerDraftDateChange = this.renderCustomerDraftDateChange.bind(this)
  }

  componentDidMount () {
    this.setState({
      oldDate: this.props.oldDate,
      newDate: this.props.newDate,
      shopName: this.props.shopName,
      clientName: this.props.clientName,
      reason: 1,
      comment: '',
      confirmed: false
    })
  }

  componentWillReceiveProps (newProps) {
    this.setState({
      oldDate: newProps.oldDate,
      newDate: newProps.newDate,
      shopName: this.props.shopName,
      clientName: this.props.clientName,
      reason: 1,
      comment: '',
      confirmed: newProps.confirmed
    }, () => {
      // console.log('OldDate', this.state.oldDate, ' NewDate', this.state.newDate)
    })
  }

  onChange (e) {
    e.persist()
    let value = e.target.value
    let name = ''
    if (e.target.type === 'radio') {
      if (e.target.name === 'Reason') {
        name = 'reason'
        value = parseInt(value)
      }
    }
    if (e.target.name === 'Comment') {
      name = 'comment'
      value = e.target.value
    }
    if (e.target.type === 'checkbox') {
      name = e.target.name
      value = !this.state[name]
    }

    this.setState({
      [name]: value
    }, () => {
      // this.onBlur(e)
    })
  }

  onSave (e) {
    e.preventDefault()
    if (this.props.isCustomerDraft !== true) {
      let momentDate = moment(this.state.newDate)
      this.setState({
        confirmed: true
      }, () => {
        // updateFromDeliveryTime
        this.props.onSave({
          DeliveryChangeReason: this.state.reason,
          DeliveryChangeComment: this.state.comment,
          Confirmed: this.state.confirmed,
          NewDate: momentDate.format('YYYY-MM-DDTHH:mm:ss'),
          CommentApplyToInvoice: this.state.ApplyToInvoice,
          CommentShowToCustomer: this.state.ShowToCustomer
        })
      })
    } else {
      this.props.onSave(this.props.newDate)
    }
  }
  onClose (e) {
    e.preventDefault()
    this.setState({
      confirmed: true
    }, () => {
      if (this.props.isCustomerDraft !== true) {
        this.props.onClose()
      } else {
        this.props.onSave(this.props.oldDate)
      }
    })
  }

  renderForm () {
    let deliveryChangeReason = this.state.reason
    let deliveryChangeComment = this.state.comment
    let fromDate = renderFullDate(this.state.oldDate)

    let toDate = renderFullDate(this.state.newDate, false)
    let toDateTime = renderFullDate(this.state.newDate, true, true)

    let client = this.state.clientName
    let shop = this.state.shopName

    // console.log('Dates', fromDate, toDate)
    let times = this.props.times
    let timeString = toDateTime

    let timeKey = 'Time_' + moment(this.state.newDate).format('DD-MM-YYYY_HH:mm') + Math.random()

    const onChangeTime = (e) => {
      let datetime = this.state.newDate
      let splitted = e.target.value.split(':')
      let dateVal = (datetime !== null) ? window.CustomDate(datetime) : window.CustomDate()
      let momentDate = moment(dateVal)
      momentDate.set({ hour: splitted[0], minute: splitted[1], second: 0, millisecond: 0 })
      this.setState({
        newDate: momentDate.format('YYYY-MM-DDTHH:mm:ss')
      }, () => {
        // console.log('state', this.state.newDate)
      })
    }
    return (
      <div>
        <LabelWrapper labelText={translation('1109')}>
          <div className='date-text'>{fromDate}</div>
        </LabelWrapper>
        <LabelWrapper labelText={translation('1110')}>
          <Inline block>
            <span>{toDate + ' - '}</span>
            <DropDown value={timeString} onChange={onChangeTime} ref='TimeString' key={timeKey}>
              {times.map((val, index) => <option value={val} key={index}>{val}</option>)}
            </DropDown>
          </Inline>
        </LabelWrapper>
        <LabelWrapper labelText={translation('1111')}>
          <Radio id='Reason_Shop' name='Reason' value='2' onChange={this.onChange} checked={deliveryChangeReason === 2} labelText={shop} />
          <Radio id='Reason_Client' name='Reason' value='1' onChange={this.onChange} checked={deliveryChangeReason === 1} labelText={client} />
        </LabelWrapper>
        <Textarea name='Comment' value={deliveryChangeComment} onChange={this.onChange} labelText={translation('149')} />
        <Divider noLine />
        {hasSubscriptionPermission(this.props.auth, 10) && this.props.auth.user.CustomerId === '-1' && (
          <Check id='ApplyToInvoice' name='ApplyToInvoice' value='yes' onClick={this.onChange} checked={this.state.ApplyToInvoice} labelText={translation('1785')} />
        )}
        {hasSubscriptionPermission(this.props.auth, 10) && this.props.auth.user.CustomerId === '-1' && (
          <Check id='ShowToCustomer' name='ShowToCustomer' value='yes' onClick={this.onChange} checked={this.state.ShowToCustomer} labelText={translation('17857')} />
        )}
      </div>
    )
  }

  renderCustomerDraftDateChange () {
    let fromDate = renderFullDate(this.state.oldDate)
    let toDate = renderFullDate(this.state.newDate)
    return (
      <div>
        <ul className='delivery_dates clearfix'>
          <li className='line wide'>
            <div className='delivery-text wide'>{translation('14738')}</div>
          </li>
          <LabelWrapper labelText={translation('14737')}>
            <div className='delivery-text'>{fromDate}</div>
          </LabelWrapper>
          <Button onClick={this.onClose} labelText={translation('14726')} />
          <LabelWrapper labelText={translation('14736')}>
            <div className='delivery-text'>{toDate}</div>
          </LabelWrapper>
          <Button onClick={this.onSave} labelText={translation('14727')} />
        </ul>
      </div>
    )
  }

  render () {
    if (this.props.isCustomerDraft !== true) {
      return (
        <div className='deliverychange_modal'>
          <Modal
            {...this.props}
            header={translation('1108')}
            overflowHidden={this.state.overflowHidden}
            icon={ModalIcons.Plus}
            bottomBarProps={{
              actionLabelText: translation('956'),
              onActionClick: this.onSave
            }}
          >
            {this.renderForm()}
          </Modal>
        </div>
      )
    } else {
      return (
        <div className='deliverychange_modal'>
          <Modal {...this.props} onClose={this.onClose} header={translation('1108')}
            icon={ModalIcons.Plus}>
            {this.renderCustomerDraftDateChange()}
          </Modal>
        </div>
      )
    }
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {

})(DeliveryDateChangeModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/DeliveryDateChangeModal/index.js